import { ContentCreator$, ContentHouse } from 'models'
import { Group } from '../group'
export class ContentHouseGroup extends Group<ContentHouse, ContentCreator$> {
  getMemberId(item: ContentCreator$): string {
    return item.id
  }
  membershipRequests(): ContentCreator$[] {
    return this.group.membershipRequests
  }
  invitees(): ContentCreator$[] {
    return this.group.invitees
  }
  members(): ContentCreator$[] {
    return this.group.members
  }
  readers(): string[] {
    return this.group.readers
  }
  set(key: string, value: number) {
    return (this.group.config[key] = value)
  }
  writers(): string[] {
    return this.group.writers
  }
  admins(): string[] {
    return this.group.admins
  }
  has(key: string): boolean {
    return this.group.config.hasOwnProperty(key)
  }
  get(key: string): number {
    return this.group.config[key]
  }
}
